import Vue from "vue";
import { bookinglistings } from "@lab/api/meetings.api";
import { Booking, BookingDetial } from "@lab/types/bookings";
import { bookingDateFields } from "@lab/meta/bookings";
import { is_date_set } from "@lab/utils/format";

const state = {
	errorMessage: null,
	filters: {
		healthserviceid: 0,
		hospitalid: 0,
		searchname: null,
		status: null,
		meetingtype: null,
		upcoming: false
	},
	isFetching: false,
	lastFetched: null, // Timestamp
	meetings: []
};
const getters = {
	callouts: (state) =>
		state.meetings.filter((item) => item.type === "callout"),
	excelCallouts: (state, getters) => {
		return `${
			process.env.VUE_APP_SERVICES
		}/bookinglistings/users/${getters.user.id.toString()}/list/callout.xlsx?jwt=${
			getters.token
		}`;
	},
	excelSitetours: (state, getters) => {
		return `${
			process.env.VUE_APP_SERVICES
		}/bookinglistings/users/${getters.user.id.toString()}/list/site-tour.xlsx?jwt=${
			getters.token
		}`;
	},
	error: (state): string => state.errorMessage,
	fetching: (state): boolean => state.isFetching,
	filters: (state) => state.filters,
	meetings: (state) => state.meetings,
	sitetours: (state) =>
		state.meetings.filter((item) => item.type === "site-tour"),
	token: (_) => window.localStorage.getItem("token"),
	user: (state, getters, rootState, rootGetters) =>
		rootGetters["userModule/get"]
};
const actions = {
	async fetch({ commit, dispatch }) {
		commit("LOAD_START");

		const _meetings = await bookinglistings.fetch();

		if (_meetings) {
			return dispatch("prepare", _meetings);
		}
		commit(`LOAD_FINISH`);
	},
	prepare({ commit }, meetings: BookingDetial[]) {
		if (meetings.length) {
			meetings.forEach((booking) => {
				bookingDateFields.forEach((field) => {
					booking[field] = is_date_set(booking[field])
						? new Date(booking[field])
						: null;
				});
			});
		}

		commit("LOAD_MEETINGS_SUCCESS", meetings);

		commit("LOAD_FINISH");
	},
	updateFilters({ commit }, option) {
		commit(`UPDATE_FILTER`, option);
	}
};
const mutations = {
	LOAD_MEETINGS_SUCCESS(state: any, bookings: Booking[]) {
		Vue.set(state, "meetings", bookings);
	},
	LOAD_FINISH(state: any) {
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	UPDATE_FILTER(state, option) {
		const { name, value } = option;
		Vue.set(state.filters, name, value);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
